
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";

import { UploadOutlined } from '@ant-design/icons';
import { Button as Btn, Card, Upload, message } from 'antd';

import { Checkbox, Row, Col, Input } from 'antd';

import { TableContainer, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

import { Backdrop, Button, CircularProgress, FormControlLabel, Radio, RadioGroup, TextField, Lable, Grid, Box, Container, useMediaQuery } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

import { TextareaAutosize } from '@mui/base/TextareaAutosize';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';

// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';

// import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { LuMailWarning } from "react-icons/lu";

const { TextArea } = Input;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

      const useStyles = makeStyles({
        root: {
          //fontFamily: 'Times New Roman',
          //fontWeight: '600',
        },
      });
     

 const ServiceClaimPending = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const Token_no = location.state.Token_no;
  const Serial_no = location.state.Serial_no;
  const login_id = location.state.login_id;
  const Item_code1 = location.state.Item_code;
  const Pending = location.state.Pending;
  const BRANCH_CODE = location.state.BRANCH_CODE;
  const doc_number = location.state.doc_number;

  // const Item_code = trimp(Item_code);
  const Item_code = Item_code1.trim();

  console.log('data', Token_no,Serial_no,login_id,Item_code,Pending);
 
  const [serialNoImage, setSerialNoImage] = useState([]);
  const [motorComponentImage, setMotorComponentImage] = useState([]);
  const [pumpComponentImage1, setPumpComponentImage1] = useState([]);
  const [pumpComponentImage2, setPumpComponentImage2] = useState([]);

  const [open, setOpen] = React.useState(false);

  
  const [selectedValues, setSelectedValues] = useState([]);

  const [UploadInvImg, setUploadInvImg] = useState([]);


  const [DealerCodes, setDealerCodes] = useState([]);
  const [productcode, setproductcode] = useState([]);
  const [servicerType, setServicerType] = useState([]);
  const [scrnumber, setScrnumber] = useState([]);
  
  const [dealerlist, setDealerList] = useState([]);
  const [receiveditem, setReceivedItem] = useState([]);
  const [complaintCategory, setComplaintCategory] = useState([]);
  const [labourServiceCharge, setLabourServiceCharge] = useState([]);
  const [itemdetailsList, setItemdetailsList] = useState([]);
  const [rewindingtable, setRewindingtable] = useState([]);
  const [quantityweight, setQuantityweight] = useState([]);
  const [unitCost, setUnitCost] = useState([]);
  const [labourServiceCost, setLabourServiceCost] = useState([]);
  const [conditionOfService, setConditionOfService] = useState([]);
  // const [ascCode, setAscCode] = useState([]);

  const [tollFreeComment, setTollFreeComment] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [natureooffault, setNatureooffault] = useState('');
  const [natureooffaultList, setNatureooffaultList] = useState([]);
  const [complaintTypeList, setComplaintTypeList] = useState([]);
  const [complaintTypeReason, setComplaintTypeReason] = useState([]);
  const [labourServiceChargeList, setLabourServiceChargeList] = useState([]);
  const [itemdetails, setItemdetails] = useState([]);
  const [rewindingList, setRewindingList] = useState('');
  const [repairsList, setRepairsList] = useState('S101');
  const [labPurgrid, setLabPurgrid] = useState([]);
  const [sparesgrid, setSparesgrid] = useState([]);
 
  
  const [km, setKm] = useState([]);
  const [selectedService, setSelectedService] = useState('');

  const [selectedCode, setSelectedCode] = useState('');

  
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptions1, setSelectedOptions1] = useState([]);
  const [visibleCount, setVisibleCount] = useState(5);


//-------------value input typing change data get functions ------
  const [windingamount, setWindingamount] = useState('');
  const [address, setAddress] = useState([]);
  const [reported, setReported] = useState('');
const [checked, setChecked] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
  });
  const [itemsearch, Setitemsearch] = useState([]);
  const [isDataFromAPI, setIsDataFromAPI] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
const [replacement_no, setreplacement_no] = useState(false);
  const itemsearchbutton = () => {
    setOpen(true);
    if(!itemsearch){
      alert('Please Enter the Item');
      setOpen(false);
      return;
    }
    otherspares();
  }
  
  const otherspares = async () => {
    setOpen(true);
    const formData = new FormData();
    formData.append("item", itemsearch);
    formData.append("login_id", login_id);
    formData.append("branchcode", BRANCH_CODE);

  axios.post(BASE_URL + "/otherspares", formData)
      .then(response => {
        //alert('1');
        
        console.log('data value', response.data);
          if (response.data && response.data.otherspares) {
           // alert('1');
            //alert('2');
            const itemArray = response.data.otherspares;
              // setItemdetails(response.data.data);
              setItemdetails(itemArray);

              //console.log('deepa',response.data.data);
              setOpen(false);
          } else {
           // alert('2');
      setOpen(false);
              console.error('Nature_of_fault not found in response', response.data);
          }
      })
      .catch(error => {
        console.error('Error:', error);
        setOpen(false);
      });
  };

  const sendToAPI = async (updatedCheckboxes) => {
    try {
      const response = await fetch( BASE_URL + '/fieldVisitCheckBox', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(updatedCheckboxes),
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setLabourServiceCharge(data.field_visit_check_box);
      console.log('Success:', data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handlechkbxxx = () => {
   
    setChecked(!checked);
   
  };
    useEffect(() => {
      
      if (!checked) {
        fetchData1();
      }
      else{
  
      }
    }, [checked]);
    const fetchData1 = async () => {

      const formData = new FormData();
      formData.append("item_code", Item_code);
      formData.append("serial_no", Serial_no);
      formData.append("branch_code", BRANCH_CODE);

    axios.post(BASE_URL + "/boncomp", formData)
        .then(response => {

          console.log('data value', response.data);
            if (response.data && response.data.data) {
              const itemArray = Object.values(response.data.data);
                setItemdetails(itemArray);
               //setIsDataFromAPI(true);
            } else {
                console.error('Nature_of_fault not found in response', response.data);
            }
        })
        .catch(error => console.error('Error:', error));
    };
  // const handleCheckboxChangeVisit = (e) => {
  //   const { name, checked } = e.target;
  //   let updatedCheckboxes;

  //   if (name === 'checkbox3' && checked) {
  //     // If the third checkbox is checked, uncheck the first two
  //     updatedCheckboxes = {
  //       checkbox1: false,
  //       checkbox2: false,
  //       checkbox3: true,
  //     };
  //   } else if ((name === 'checkbox1' || name === 'checkbox2') && checked) {
  //     // If the first or second checkbox is checked, uncheck the third checkbox
  //     updatedCheckboxes = {
  //       ...checkboxes,
  //       [name]: checked,
  //       checkbox3: false,
  //     };
  //   } else {
  //     // Otherwise, update the state normally
  //     updatedCheckboxes = {
  //       ...checkboxes,
  //       [name]: checked,
  //     };
  //   }

  //   setCheckboxes(updatedCheckboxes);
  //   updateSelectedValues(updatedCheckboxes);
  //   sendToAPI(updatedCheckboxes); // Send updated state to API
  // };
  
    const handleCheckboxChangeVisit = (e) => {
        if (filteredTable.length > 0 || filteredTable1.length > 0) {
      Swal.fire('', "Before Changing Complaint Type Please clear Spare and Labour Transactions", 'info');
      return;
    }
      const { name, checked } = e.target;
      let updatedCheckboxes;
  
      if (name === 'checkbox3' && checked) {
        // If the third checkbox is checked, uncheck the first two
        updatedCheckboxes = {
          checkbox1: false,
          checkbox2: false,
          checkbox3: true,
        };
      } else if ((name === 'checkbox1' || name === 'checkbox2') && checked) {
        // If the first or second checkbox is checked, uncheck the third checkbox
        updatedCheckboxes = {
          ...checkboxes,
          [name]: checked,
          checkbox3: false,
        };
      } else {
        // Otherwise, update the state normally
        updatedCheckboxes = {
          ...checkboxes,
          [name]: checked,
        };
      }
    
  
      // {checkboxes.checkbox1 && <p>FIELD VISIT</p>}
      //     {checkboxes.checkbox2 && <p>REGULAR REPAIR</p>}
      //     {checkboxes.checkbox3 && <p>FULL FINISH</p>}
  
      setCheckboxes(updatedCheckboxes);
      updateSelectedValues(updatedCheckboxes);
      sendToAPI(updatedCheckboxes); // Send updated state to API
    };


  const updateSelectedValues = (updatedCheckboxes) => {
    const newSelectedValues = [];
    if (updatedCheckboxes.checkbox1) newSelectedValues.push('FIELD_VISIT');
    if (updatedCheckboxes.checkbox2) newSelectedValues.push('REGULAR_REPAIR');
    if (updatedCheckboxes.checkbox3) newSelectedValues.push('FULL_FINISH');
    setSelectedValues(newSelectedValues);
  };

 


  useEffect(() => {
    
    const fetchData = async () => {
		setOpen(true);
      const formdata = new FormData();
      formdata.append("login_id", login_id);
      formdata.append("doc_number", doc_number);
      formdata.append("Token_NO", Token_no);
      formdata.append("serialno", Serial_no);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };

      try {
        const response = await fetch(BASE_URL + "/getrejectclaimdetails", requestOptions);
        const text = await response.text();

        const data = JSON.parse(text);
           const replacement_noo = Array.isArray(data.replacement_no)
      ? data.replacement_no
      : [data.replacement_no];

    if (replacement_noo.length > 0 && replacement_noo[0]?.ReplacementReferenceNo) {
      setreplacement_no(true);
    }
        console.log('reject claim ', data);
        // Check if the response contains an array or a single code and handle accordingly
        const codes = Array.isArray(data.Dealer_code) ? data.Dealer_code : [data.Dealer_code];
        const PRODUCT_CODE = Array.isArray(data.PRODUCT_CODE) ? data.PRODUCT_CODE : [data.PRODUCT_CODE];
        const service_no = Array.isArray(data.service_no) ? data.service_no : [data.service_no];
        const SCR_no = Array.isArray(data.BRANCH_CODE) ? data.BRANCH_CODE : [data.BRANCH_CODE];
        // const ADDRESS_LIST = Array.isArray(data.ADDRESS_LIST) ? data.ADDRESS_LIST : [data.ADDRESS_LIST];
        const Dealer_list = Array.isArray(data.Dealer_list) ? data.Dealer_list : [data.Dealer_list];
        const RECEIVED_ITEM = Array.isArray(data.Receiveditem) ? data.Receiveditem : [data.Receiveditem];
        const complaint_category = Array.isArray(data.complaint_category) ? data.complaint_category : [data.complaint_category];
        const NatureofFault = Array.isArray(data.NatureofFault) ? data.NatureofFault : [data.NatureofFault];
        const Complaint_Type = Array.isArray(data.Complaint_Type) ? data.Complaint_Type : [data.Complaint_Type];
        const ComplaintReason = Array.isArray(data.ComplaintReason) ? data.ComplaintReason : [data.ComplaintReason];
        const labour_service_charge  = Array.isArray(data.service_name ) ? data.service_name  : [data.service_name];
        const conditionofservice  = Array.isArray(data.conditionofservice ) ? data.conditionofservice  : [data.conditionofservice];
        const tables_data  = Array.isArray(data.tables_data ) ? data.tables_data  : [data.tables_data];
        // const ASCcode = Array.isArray(data.ASCcode) ? data.ASCcode : [data.ASCcode];
        

        setDealerCodes(codes);
        setproductcode(PRODUCT_CODE);
        setServicerType(service_no);
        setScrnumber(SCR_no);
        // setAddress(ADDRESS_LIST);
        setDealerList(Dealer_list);
        setReceivedItem(RECEIVED_ITEM);
        setComplaintCategory(complaint_category);
        setLabourServiceCharge(labour_service_charge);
        setNatureooffaultList(NatureofFault);
        setComplaintTypeReason(ComplaintReason);
        setComplaintTypeList(Complaint_Type);
        setConditionOfService(conditionofservice);
        setRewindingtable(tables_data);

        setSelectedCode(codes[0]);
        
        console.log('selectedCode:', selectedCode);

        console.log('complaintCategory:', complaint_category);
        const defaultCategory = complaint_category.find(item => item.STATUS === "1");
        if (defaultCategory) {
          
          
          setSelectedCategory(defaultCategory.Results);
          fetchNatureOfFault(defaultCategory.Results);
        }

        const NatureofFault1 = NatureofFault.find(item => item.STATUS === "1");
        if (NatureofFault1) {
          
          
          setNatureooffault(NatureofFault1.Results);
          
        }

        console.table('Complaint_Type:', Complaint_Type);
const initialSelectedOptions = Complaint_Type.filter(item => item.ISVERIFIED === "1");
// setComplaintTypeList(Complaint_Type);
setSelectedOptions(initialSelectedOptions);

console.table('ComplaintReason:', ComplaintReason);
const ComplaintReason1 = ComplaintReason.filter(item => item.ISVERIFIED === "1");
// setComplaintTypeList(Complaint_Type);
setSelectedOptions1(ComplaintReason1);

const initialCheckboxes = {
  checkbox1: conditionofservice.some(item => item.condition_of_service === 'FIELD VISIT' && item.status === '1'),
  checkbox2: conditionofservice.some(item => item.condition_of_service === 'REGULAR REPAIR' && item.status === '1'),
  checkbox3: conditionofservice.some(item => item.condition_of_service === 'FULL FINISH' && item.status === '1'),
};
setCheckboxes(initialCheckboxes);
updateSelectedValues(initialCheckboxes);
setOpen(false);
      } catch (error) {
		  setOpen(false);
        console.error("Error fetching or parsing data:", error);
        setDealerCodes([]);
        setSelectedCode(''); // Reset selected code on error
      }
    };
fetchData1();
    // const fetchData1 = async () => {

    //   const formData = new FormData();
    //   formData.append("item_code", Item_code);
    //   formData.append("serial_no", Serial_no);
    //   formData.append("branch_code", BRANCH_CODE);

    // axios.post(BASE_URL + "/boncomp", formData)
    //     .then(response => {

    //       console.log('data value', response.data);
    //         if (response.data && response.data.data) {
              
    //             setItemdetails(response.data.data);
    //         } else {
    //             console.error('Nature_of_fault not found in response', response.data);
    //         }
    //     })
    //     .catch(error => console.error('Error:', error));
    // };

    const fetchData2 = async () => {

      const formData = new FormData();
      formData.append("SERIAL_NO", Item_code);
      formData.append("MAT_CODE", Serial_no);
  
      axios.post(BASE_URL + "/labpurgridwied", formData)
          .then(response => {
              if (response.data && response.data.Labpurgrid) {
                  setLabPurgrid(response.data.Labpurgrid);
              } else {
                  console.error('Nature_of_fault not found in response', response.data);
              }
          })
          .catch(error => console.error('Error:', error));
      };

      const fetchData3 = async () => {

        const formData = new FormData();
        formData.append("SERIAL_NO", Item_code);
        formData.append("MAT_CODE", Serial_no);
    
        axios.post(BASE_URL + "/sparesgridwied", formData)
            .then(response => {
                if (response.data && response.data.Sparesgrid) {
                    setSparesgrid(response.data.Sparesgrid);
                } else {
                    console.error('Nature_of_fault not found in response', response.data);
                }
            })
            .catch(error => console.error('Error:', error));
        };

        const fetchData4 = async () => {

          const formData = new FormData();
          formData.append("login_id", login_id);
          formData.append("item_code", Item_code);
          formData.append("branch_code", BRANCH_CODE);
      
          axios.post(BASE_URL + "/gethpandpsgagainstitemandbranch", formData)
              .then(response => {
                  if (response.data && response.data.Sparesgrid) {
                      setSparesgrid(response.data.Sparesgrid);
                  } else {
                      console.error('Nature_of_fault not found in response', response.data);
                  }
              })
              .catch(error => console.error('Error:', error));
          };

    fetchData();
    fetchData1();
    // fetchData2();
    // fetchData3();
    fetchData4();
  }, []);

  const DealerCodehandleChange = (event) => {
    setSelectedCode(event.target.value);
  };

  const ItemdetailshandleChange = (event) => {
    setItemdetailsList(event.target.value);
  };

  const rewindingchargehandle = (event) => {
    setRewindingList(event.target.value);
  };
  
  const repairshandle = (event) => {
    setRepairsList(event.target.value);
  };

   const LabourServiceChargeHandel = (event) => {

    console.log('laberservice data',event.target.value);
    const value = event.target.value;
    setSelectedService(value.service_id);
    setLabourServiceChargeList(value);
    if(selectedService != 'S106'){
      setLabourServiceCost("");
      setKm("");
    }
  };

  const kmcharges = (event) => {

          console.log(event.target.value);
          setKm(event.target.value);

          

          const formdata = new FormData();
            formdata.append("item_type", labourServiceChargeList.service_id);
            formdata.append("km", event.target.value);

            axios.post(BASE_URL +"/getKmcharges", formdata)
        .then(response => {

          if(response.data.status_code == 400){

            Swal.fire('No Data', response.data.message, 'info');
        
          }else{

            setLabourServiceCost(response.data.price[0].price);
      //setRewindingtable(response.data.data);
        
          }
        console.log('data value response1', response.data);

        }).catch(error => {

          if(error.response.data.status_code == 400){
          
          Swal.fire('No Data', error.response.data.message[0], 'error');
          }
        });

  }





  // ------ 
  const itemsearchchange =(e) => {
    Setitemsearch(e.target.value);
  }
  const windingAmounChange = (event) => {
    setWindingamount(event.target.value);
  };
  
  const addressChangehandle = (event) => {
   
    setAddress(event.target.value);
  };
  
  const ReportedChangehandle = (event) => {
    setReported(event.target.value);
  };

  const quantityweightChange =(e) => {
    setQuantityweight(e.target.value);
  }
   const unitCostChange =(e) => {
    setUnitCost(e.target.value);
  }

  const labourServiceCostChage = (e) => {
    setLabourServiceCost(e.target.value);
  }


  // -------- Button Click function ------


  const RewindingFormSubmit =() => {
	  setOpen(true);
    if(rewindingList == ''){
        alert('please select rewinding charges');
        setOpen(false);
        return;
    }

    if (windingamount === '' || windingamount === '0' || windingamount === '0.' || windingamount == 0) {
      alert('Rewinding Cost Not Add');
      setOpen(false);
      return;
  }
// productcode.length > 0 ? productcode[0].ASC_NAME : ''
  if(productcode[0].ASC_NAME == ''){
    alert('ASC Name Not Add');
    setOpen(false);
    return;
}

if(reported == ''){
  alert('Please Enter the complaint');
  setOpen(false);
  return;
}


if(checkboxes.checkbox1 == false && checkboxes.checkbox2 == false && checkboxes.checkbox3 == false){
  alert('Condition Of Service Not select');
  setOpen(false);
  return;
}

if(selectedCategory == ''){
  alert('Complaint Category Not Select');
  setOpen(false);
  return;
}

if(natureooffault == ''){
  alert('Nature of fault Not Select');
  setOpen(false);
  return;
}

if(selectedOptions == ''){
  alert('Complaint Type not select');
  setOpen(false);
  return;
}


if(selectedOptions1 == ''){
  alert('Complaint Reason not select');
  setOpen(false);
  return;
}



  
    const formdata = new FormData();
formdata.append("login_id", login_id);
formdata.append("item_type", rewindingList);
formdata.append("amount", windingamount);
formdata.append("branch_code", BRANCH_CODE);
formdata.append("service_center_code", productcode.length > 0 ? productcode[0].ASC_CODE : '');
formdata.append("item_code", Item_code);
formdata.append("tokenno", Token_no);

// const requestOptions = {
//   method: "POST",
//   body: formdata,
//   redirect: "follow"
// };

axios.post(BASE_URL +"/getwindingwirecharges", formdata)
  .then(response => {

    if(response.data.status_code == 400){
setOpen(false);
      Swal.fire('No Data', response.data.message, 'info');
  
    }else{
setOpen(false);
setRewindingtable(response.data.data);
  
    }
  console.log('data value response1', response.data);

  }).catch(error => {

    if(error.response.data.status_code == 400){
    setOpen(false);
    Swal.fire('No Data', error.response.data.message[0], 'error');
    }
  });


        console.log("Rewinding Form Submit", rewindingList, windingamount, repairsList);
  }



   useEffect(() => {
    if (productcode.length > 0) {
      setReported(productcode[0].COMMENTS);
      setAddress(productcode[0].CUSTOMER_ADDRESS);
      setTollFreeComment(productcode[0].TOKENCOMMENTS);
    }
  }, [productcode]);


  const handleChange = (event) => {
    const natureOfFault = event.target.value;
    setSelectedCategory(natureOfFault);
    fetchNatureOfFault(natureOfFault);
  };

  const  tollfreeComments =(e) => {
    setTollFreeComment(e.target.value);
  }


  const fetchNatureOfFault = (category) => {
	  setOpen(true);
    // const natureOfFault = event.target.value;
  
    // // setNatureooffault(natureOfFault);
    // setSelectedCategory(natureOfFault);
  
    // fetchNatureOfFault(natureOfFault);
    const formData = new FormData();
    formData.append("complaintcategory", category);

    axios.post(BASE_URL + "/naturefault", formData)
        .then(response => {
            if (response.data && response.data.Nature_of_fault) {
				setOpen(false);
                setNatureooffaultList(response.data.Nature_of_fault);
            } else {
				setOpen(false);
                console.error('Nature_of_fault not found in response', response.data);
            }
        })
        .catch(error => {
			setOpen(false);
			console.error('Error:', error)});
};

const handleChange1 = (event) => {
	setOpen(true);
  setNatureooffault(event.target.value);

  const formdata = new FormData();
formdata.append("Serial_no", Serial_no);
formdata.append("Complainttype", event.target.value);

axios.post(BASE_URL + '/ComplaintType',formdata).then((response) => {

  if(response.data.status_code == 404){
setOpen(false);
    Swal.fire('No Data', 'No data found.', 'info');

  }else{
setOpen(false);
    setComplaintTypeList(response.data.complaint_type);
  }

  })
  .catch((error) => {
   setOpen(false);
    console.error(error);
    
  });
  };


  const SparesReplacedClick = () => {

    setOpen(true);
if(reported == ''){
  alert('Please Enter the complaint');
  setOpen(false);
  return;
}


if(checkboxes.checkbox1 == false && checkboxes.checkbox2 == false && checkboxes.checkbox3 == false){
  alert('Condition Of Service Not select');
  setOpen(false);
  return;
}

if(selectedCategory == ''){
  alert('Complaint Category Not Select');
  setOpen(false);
  return;
}

if(natureooffault == ''){
  alert('Nature of fault Not Select');
  setOpen(false);
  return;
}

if(selectedOptions == ''){
  alert('Complaint Type not select');
  setOpen(false);
  return;
}


if(selectedOptions1 == ''){
  alert('Complaint Reason not select');
  setOpen(false);
  return;
}

    console.log('data value', itemdetailsList);

    const formdata = new FormData();
formdata.append("login_id", login_id);
formdata.append("item_type", itemdetailsList);
formdata.append("amount",unitCost );
formdata.append("quantity", quantityweight);
formdata.append("serialnumber", Serial_no);
formdata.append("branch_code", BRANCH_CODE);
formdata.append("service_center_code", productcode.length > 0 ? productcode[0].ASC_CODE : '');
formdata.append("item_code", Item_code);
formdata.append("tokenno", Token_no);

axios.post(BASE_URL + '/getsparecharges',formdata).then((response) => {

  if(response.data.status_code == 400){
setOpen(false);
    Swal.fire('No Data', response.data.message, 'info');

  }else{
	  setOpen(false);
    Swal.fire('Success', response.data.message, 'Success');
    setRewindingtable(response.data.data);
  }

  })
  .catch((error) => {
	 setOpen(false); 
    Swal.fire('', error.response.data.message[0], 'question');
    console.error(error);
    
  });


  }


  const laberserviceHandleclicke = () => {
setOpen(true);
        
if(reported == ''){
  alert('Please Enter the complaint');
  setOpen(false);
  return;
}


if(checkboxes.checkbox1 == false && checkboxes.checkbox2 == false && checkboxes.checkbox3 == false){
  alert('Condition Of Service Not select');
  setOpen(false);
  return;
}

if(selectedCategory == ''){
  alert('Complaint Category Not Select');
  setOpen(false);
  return;
}

if(natureooffault == ''){
  alert('Nature of fault Not Select');
  setOpen(false);
  return;
}

if(selectedOptions == ''){
  alert('Complaint Type not select');
  setOpen(false);
  return;
}


if(selectedOptions1 == ''){
  alert('Complaint Reason not select');
  setOpen(false);
  return;
}

  console.log('laber service  cost' , labourServiceChargeList);

    const formdata = new FormData();
         formdata.append("login_id", login_id);
         formdata.append("item_type", labourServiceChargeList.service_id);
         formdata.append("item_type_description", labourServiceChargeList.service_name);
         formdata.append("amount", labourServiceCost);
         formdata.append("serialnumber", Serial_no);
         formdata.append("branch_code", BRANCH_CODE);
         formdata.append("service_center_code", productcode.length > 0 ? productcode[0].ASC_CODE : '');
         formdata.append("item_code", Item_code);
         formdata.append("tokenno", Token_no);


         axios.post(BASE_URL + '/getspareandlabourcharges',formdata).then((response) => {

          if(response.data.status_code == 400){
        setOpen(false);
            Swal.fire('No Data', response.data.message, 'info');
        
          }else{
			  setOpen(false);
            //Swal.fire('Success', response.data.message, 'Success');
            setRewindingtable(response.data.data);
          }
        
          })
          .catch((error) => {

            if(error.response.data.status_code == 400){
setOpen(false);
              Swal.fire('', error.response.data.message[0], 'question');
            }
            
          });

  }


  const handleCheckboxChange = (option) => {
	  setOpen(true);
    const selectedIndex = selectedOptions.findIndex((item) => item.COMPLAINTTYPE === option.COMPLAINTTYPE);
    let newSelected = [...selectedOptions];

    if (selectedIndex === -1) {
      newSelected.push(option);
    } else {
      newSelected.splice(selectedIndex, 1);
    }

    if(newSelected == ''){
      setComplaintTypeList([]);
      setComplaintTypeReason([]);
      setSelectedOptions([]);
      return;
    }else {

      setSelectedOptions(newSelected);
    }


    const formdata = new FormData();

    const complaintTypes = newSelected.map(item => item.COMPLAINTTYPE);
  formdata.append("COMPLAINTTYPE", JSON.stringify(complaintTypes));

    axios.post(BASE_URL + '/ComplaintReason',formdata).then((response) => {
		setOpen(false);
      setComplaintTypeReason(response.data.complaint_reason);
      })
      .catch((error) => {
		  setOpen(false);
        console.error(error);
      });
  };
  
  const handleCheckboxChange1 = (option) => {
    const selectedIndex1 = selectedOptions1.findIndex((item) => item.COMPLAINTREASON === option.COMPLAINTREASON);
    let newSelected1 = [...selectedOptions1];

    if (selectedIndex1 === -1) {
      newSelected1.push(option);
    } else {
      newSelected1.splice(selectedIndex1, 1);
    }

    if(newSelected1 == ''){
      setComplaintTypeReason([]);
      setSelectedOptions1([]);
    }else {
      setSelectedOptions1(newSelected1);

    }

  };

  // const acceptedFileTypes = ['image/jpeg', 'image/png'];
  // const InvoiceImage = {
  //   onRemove: (file) => {
  //     setUploadInvImg([]);
  //     const index = UploadInvImg.indexOf(file);
  //     const newFileList = UploadInvImg.slice();
  //     newFileList.splice(index, 1);
  //     setUploadInvImg(newFileList);
  //   },
  //   beforeUpload: (file) => {
  //     setUploadInvImg([]);
  //     const index = UploadInvImg.indexOf(file);
  //     const newFileList = UploadInvImg.slice();
  //     newFileList.splice(index, 1);
  //     setUploadInvImg(newFileList);

  //     const isAcceptedFileType = acceptedFileTypes.includes(file.type);
  //     if (!isAcceptedFileType) {
  //       message.error('You can only upload JPEG and PNG image files!');
  //     } else {
  //       setUploadInvImg([file]);
  //     }
  //     return false;
  //   },
  //   UploadInvImg,
  // };


  const keys = labPurgrid.length > 0 ? Object.keys(labPurgrid[0]) : [];
  // const keys1 = rewindingtable.length > 0 ? Object.keys(rewindingtable[0]) : [];
  const filteredTable = rewindingtable.filter(row => row.Type == 'Spare');
  const filteredTable1 = rewindingtable.filter(row => row.Type == 'Labour');
  console.log('s data',filteredTable);

  const keys1 = filteredTable.length > 0 ? Object.keys(filteredTable[0]).filter(key => key !== 'Type'&& key !== 'id') : [];
  const keys2 = filteredTable1.length > 0 ? Object.keys(filteredTable1[0]).filter(key => key !== 'Type'&& key !== 'id') : [];


  //const calculate  = rewindingtable.filter(row => row.Total_Amount);
  const calculate1 = rewindingtable
  .filter(row => row.Type == 'Spare' && row.Total_Amount)
  .reduce((sum, row) =>{
    const amount = Number(row.Total_Amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const calculatee = Number(calculate1);
  const calculate =(calculatee*100/100);
  const formattedSum = Math.round(calculate1);
  console.log('test sum', formattedSum);


  const Labour = rewindingtable
  .filter(row => row.Type == 'Labour' && row.Total_Amount)
  .reduce((sum, row) => {
    const amount = Number(row.Total_Amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const Labour11 = Number(Labour);
  const Labour1 = (Labour11*100/100);
  const Labour2 = Math.round(Labour);
  console.log('test sum', Labour2);

  const total_Claim_Value = formattedSum + Labour2;

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        // User confirmed deletion
        try {
          await axios.post(BASE_URL + '/rewindingdelete', { id });
          Swal.fire('Deleted!', 'Your record has been deleted.', 'success');
          setRewindingtable(rewindingtable.filter(row => row.id !== id));
        } catch (error) {
          console.error('Error deleting the record:', error);
          Swal.fire('Error!', 'There was an error deleting the record.', 'error');
        }
      }
    });
  };


  const fetchMoreData = () => {
    setVisibleCount((prevCount) => prevCount + 5);
  };


  
  const acceptedFileTypes = ['image/jpeg', 'image/png'];

  const createInvoiceImageProps = (image, setImage) => ({
    onRemove: (file) => {
      const newFileList = image.filter(item => item.uid !== file.uid);
      setImage(newFileList);
    },
    beforeUpload: (file) => {
      const isAcceptedFileType = acceptedFileTypes.includes(file.type);
      if (!isAcceptedFileType) {
        message.error('You can only upload JPEG and PNG image files!');
        return false;
      }
      setImage([file]);
      return false;
    },
    fileList: image,
  });
  
  const deliverychallanhandlesubmit = () => {
    setOpen(true);
    console.log('Serial No Image:', serialNoImage);
    console.log('Motor Component Image:', motorComponentImage);
    console.log('Pump Component Image1:', pumpComponentImage1);
    console.log('Pump Component Image2:', pumpComponentImage2);
    console.log('Pump Component:', selectedOptions);

    const formdata = new FormData();
formdata.append("login_id", login_id);
formdata.append("serial_number", Serial_no);
formdata.append("servicecall_number", productcode.length > 0 ? productcode[0].SERBILLNO: '' );
formdata.append("item_code", productcode[0].MAT_CODE.trim());
formdata.append("amount", '');
formdata.append("branch_code", BRANCH_CODE);
formdata.append("dealer_code", productcode.length > 0 ? productcode[0].DEALER_CODE: '');
formdata.append("service_bill_number", '');
formdata.append("service_center_code", productcode.length > 0 ? productcode[0].ASC_CODE : '');
formdata.append("service_center_name", productcode.length > 0 ? productcode[0].ASC_NAME : '');
formdata.append("tokenno", productcode.length > 0 ? productcode[0].TOKEN_NUMBER : '');

serialNoImage.forEach(file => {
  formdata.append('serialnumber_image', file);
});

motorComponentImage.forEach(file => {
  formdata.append('motorcomponent_image', file);
});

pumpComponentImage1.forEach(file => {
  formdata.append('firstpumpcomponent_image', file);
});

pumpComponentImage2.forEach(file => {
  formdata.append('secondpumpcomponent_image', file);
});

formdata.append("customer_name", productcode.length > 0 ? productcode[0].CUSTOMER_NAME : '');
formdata.append("customer_address", address);
formdata.append("customer_phonenumber", productcode.length > 0 ? productcode[0].CUSTOMER_PHONE_NUMBER : '');
formdata.append("complaint", productcode.length > 0 ? productcode[0].COMMENTS : '');
formdata.append("complaintdate", productcode.length > 0 ? productcode[0].SERVICE_DATE : '');


formdata.append("condition_of_service", selectedValues);

  const COMPLAINTTYPE = [];
  const COMPLAINTTYPE_DESC = [];

  if (Array.isArray(selectedOptions) && selectedOptions.length > 0) {
    selectedOptions.forEach(row => {
      COMPLAINTTYPE.push(row.COMPLAINTTYPE);
      COMPLAINTTYPE_DESC.push(row.COMPLAINTTYPE_DESC);
    });

    formdata.append("defective_code", COMPLAINTTYPE);
    formdata.append("defective_description", COMPLAINTTYPE_DESC);
  }



formdata.append("natureoffault", natureooffault);
formdata.append("compaintcategory", selectedCategory);


const COMPLAINTREASON = [];
  const COMPLAINTREASON_DESC = [];

  if (Array.isArray(selectedOptions1) && selectedOptions1.length > 0) {
    selectedOptions1.forEach(row => {
      COMPLAINTREASON.push(row.COMPLAINTREASON);
      COMPLAINTREASON_DESC.push(row.COMPLAINTREASON_DESC);
    });

  formdata.append("defectivereasondescription", COMPLAINTREASON_DESC);
  formdata.append("defectivereasoncode", COMPLAINTREASON);

    // formdata.append("defective_code", COMPLAINTREASON);
    // formdata.append("defective_description", COMPLAINTREASON_DESC);
  }


formdata.append("tollfreecomments", tollFreeComment);
formdata.append("documentno", doc_number);


console.log('serviceclaimsubmit:', formdata);

axios.post(BASE_URL + '/serviceclaimmodify',formdata).then((response) => {

  if(response.data.status_code == 400){
    Swal.fire('No Data', response.data.message, 'info');
    setOpen(false);

  }else{
	  Swal.fire({
            title: 'Success',
            text: response.data.message,
            icon: 'success'
        }).then(() => {
            navigate('/home/services/service_claim_pending');
        });
    //Swal.fire('Success', response.data.message, 'Success');
    setOpen(false);
    // setComplaintTypeList(response.data.complaint_type);
  }

  })
  .catch((error) => {
    Swal.fire('', error.response.data.message[0], 'question');
    console.error(error);
    setOpen(false);
  });

  }

  return (
    <>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            <CircularProgress color="inherit" />
        </Backdrop>
      <div className="m-2 p-2">
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
          <div class="alert alert-warning" role="alert"><LuMailWarning  size={30}/> <span style={{ color: 'red', fontWeight: 'bold' }}>REJECTED COMMENTS :</span>   {productcode.length > 0 ? productcode[0].RejectedReason : ''}</div>
          <div className='col-md-12 shadow-none p-2 mb-2  rounded' style={{ background: '#FFF9C4', color: '#A50000' }}>
        <div className='d-flex'>
          <div>
        <Button onClick={() => navigate(-1)} variant="contained" endIcon={<UndoTwoToneIcon />}>Back</Button>
        </div>
        <div style={{ flex: 1 }}>
          <center>
            <h3 style={{ fontWeight: '800' }} className={classes.root}>Service Claim Entry</h3>
          </center>
          </div>
          </div>
          </div>
          <br />
          <div className='row'>
            <div className='col-md-6 mb-3'>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Name / Code</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
            <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>
      {/* <InputLabel id="dealer-code-label">Name / Code</InputLabel> */}
      <Select
        // labelId="dealer-code-label"
        value={selectedCode}
        onChange={DealerCodehandleChange}
        // label="Name / Code"
      >
        {DealerCodes.map((code, index) => (
          <MenuItem key={index} value={code}>
            {code.DEALER_CODE} / {code.DEALER_DESC}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    </Grid>
    </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Product Code / Name</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
      <Input.TextArea
      className="bg-light"
                    rows={1}
                    name='ProductCodeName'
                    value={productcode.length > 0 ? `${productcode[0].MAT_CODE.trim()} - ${productcode[0].PRODUCTDESC}` : ''}
                    // style={{ backgroundColor: 'lightgrey' }}
                  />
        {/* <TextField
          size="small"
          fullWidth
          
          variant="outlined"
          value={productcode.length > 0 ? `${productcode[0].MAT_CODE.trim()} - ${productcode[0].PRODUCTDESC}` : ''}
        /> */}
      </Grid>
    </Grid>
            {/* <Typography>Product Code / Name</Typography>
              <TextField size="small" fullWidth label="Product Code / Name" variant="outlined" value={ productcode[0].length > 0 ? productcode[0].ITEMDESCRIPTION : '' } /> */}
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Serial Number</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth variant="outlined" value={productcode.length > 0 ? productcode[0].TOKEN_NUMBER : '' } />
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Service Type</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" value={productcode.length > 0 ? productcode[0].SERVICE_TYPE : ''} />
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>SCR Number</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth variant="outlined" value={productcode.length > 0 ? productcode[0].SERBILLNO: '' } />
              </Grid>
              </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Mobile Number (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" value={productcode.length > 0 ? productcode[0].CUSTOMER_PHONE_NUMBER : ''} />
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Address (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
      <Input.TextArea
              className="bg-light"
                    rows={2}
                    name='address'
                    value={address}
                    onChange={addressChangehandle}
                  />
              {/* <TextField size="small" fullWidth  variant="outlined" name="address" onChange={addressChangehandle} value={address} /> */}
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Received From Name (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" value={productcode.length > 0 ? productcode[0].CUSTOMER_NAME : ''} />
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>ASC Name (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" value={productcode.length > 0 ? productcode[0].ASC_NAME : ''} />
           </Grid>
           </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>ASC Code</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" value={productcode.length > 0 ? productcode[0].ASC_CODE : ''} />
           </Grid>
           </Grid>
            </div>
           
            
          </div>
          <div className='row'>
            <div className='col-md-6 mb-4 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
            <Grid item xs={12} sm={4}>
              <Typography className={classes.root}>Condition Of Service (<span className="text-danger">*</span>)</Typography>
</Grid>
<Grid item xs={12} sm={8}>
<Row className={classes.root}>
      <Col span={8}>
        <Checkbox
          name="checkbox1"
          checked={checkboxes.checkbox1}
          onChange={handleCheckboxChangeVisit}
        ><b>
          FIELD_VISIT
          </b>
        </Checkbox>
      </Col>
      <Col span={8}>
        <Checkbox
          name="checkbox2"
          checked={checkboxes.checkbox2}
          onChange={handleCheckboxChangeVisit}
         // disabled={replacement_no !== null && replacement_no !== ""}
          disabled={replacement_no}
        >
          <b>
          REGULAR_REPAIR
          </b>
        </Checkbox>
      </Col>
      <Col span={8}>
        <Checkbox
          name="checkbox3"
          checked={checkboxes.checkbox3}
          onChange={handleCheckboxChangeVisit}
         // disabled={replacement_no !== null && replacement_no !== ""}
          disabled={replacement_no}
        >
          <b>
          FULL_FINISH
          </b>
        </Checkbox>
      </Col>
    </Row>
</Grid>
</Grid>

            </div>
            <div className='col-md-6 mb-4 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
            <Grid item xs={12} sm={4}>
              <Typography className={classes.root}>Received Items (<span className="text-danger">*</span>)</Typography>
              </Grid>
              <Grid item xs={12} sm={8}>
              <div className='row'>
              {receiveditem.map((row, index) => (
  <div key={index} className='col-md-6 float-right'>
    <h5>{row.ReceivedItems}</h5>
  </div>
))}
              </div>
              </Grid>
              </Grid>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Complaint Category (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
            <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>

      {/* <InputLabel id="demo-simple-select-standard-label">Complaint Category (*)</InputLabel> */}
      <Select
        // labelId="demo-simple-select-standard-label"
        id="complaintcategory"
        value={selectedCategory}
        onChange={handleChange}
        // label="Complaint Category"
      >
        <MenuItem value=""></MenuItem>
        {complaintCategory.map((row, index) => (
          <MenuItem key={index} value={row.Results}>{row.DDL}</MenuItem>
        ))}
      </Select>
    </FormControl>
    </Grid>
    </Grid>
            </div>
            <div className='col-md-6'>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Nature of fault (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
            <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>
        {/* <InputLabel id="demo-simple-select-standard-label">Nature of fault (*)</InputLabel> */}
        <Select
          // labelId="demo-simple-select-standard-label"
          id="natureoffault"
          value={natureooffault}
          onChange={handleChange1}
          // label="Age1"
        >
          <MenuItem value=""></MenuItem>
          {natureooffaultList.map((row,index) =>(
            <MenuItem key={index} value={row.Results}>{row.Results}</MenuItem>
          ))}
    
        </Select>
        </FormControl>
        </Grid>
        </Grid>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
            
<div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
{complaintTypeList.length > 0 ? (
       <>
          <Typography variant="h6" style={{ textAlign: 'center', marginTop: '10%' }} className={classes.root}>Complaint Type (<span className="text-danger">*</span>)</Typography>
          <Card style={{ width: '300px', height: '300px', overflowY: 'auto', scrollbarWidth: 'none', margin: '0 auto' }}>
            <List style={{ width: '100%' }}>
              {complaintTypeList.map((option, index) => (
                <ListItem key={index}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        checked={selectedOptions.some((item) => item.COMPLAINTTYPE === option.COMPLAINTTYPE)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={<ListItemText primary={option.COMPLAINTTYPE_DESC} />}
                  />
                </ListItem>
              ))}
            </List>
          </Card>
          </>
      ) : null}
</div>
</div>

<div className='col-md-6'>
<div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
      { complaintTypeReason.length > 0 ? (
        <>
        <Typography variant="h6" style={{ textAlign: 'center',marginTop: '10%' }} className={classes.root}>Complaint Reason (<span className="text-danger">*</span>)</Typography>
       <Card  style={{ width: '300px', height:'300px',scrollbarWidth: 'none', overflowY: 'auto' }}>

      <List style={{ width: '300px'}}>
    {complaintTypeReason.map((option, index) => (
      <ListItem key={index}>
        <FormControlLabel
          control={
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              checked={selectedOptions1.some((item) => item.COMPLAINTREASON === option.COMPLAINTREASON)}
              onChange={() => handleCheckboxChange1(option)}
            />
          }
          label={<ListItemText primary={option.COMPLAINTREASON_DESC} />}
        />
      </ListItem>
    ))}
  </List>
</Card>
</>
      ): null
      
}

    </div>
            </div>
            <div className='col-md-6 mb-3 '>
            <Grid container spacing={2} alignItems={isMobile ? 'flex-start' : 'center'}>
      <Grid item xs={12} sm={4}>
        <Typography className={classes.root}>Reported By Service Center (<span className="text-danger">*</span>)</Typography>
      </Grid>
      <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth  variant="outlined" onChange={ReportedChangehandle} value={reported} />
            </Grid>
            </Grid>
            </div>
            <div className='col-md-6 mb-3 '>
          
            </div>
          </div>

          
        </Card>
        <hr />
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
        <div className='col-md-12 shadow-none p-2 mb-2  rounded' style={{ background: '#FFF9C4', color: '#A50000' }}>
          <center>
            <h5 style={{ fontWeight: '600' }} className={classes.root} >Tollfree Details</h5>
          </center>
          </div>
          <br />
          <div className="row">
            <div className='col-md-4 mb-3'>
              <TextField size="small" fullWidth label="Tollfree/Token No (*)" variant="outlined" value={productcode.length > 0 ? productcode[0].TOKEN_NUMBER : ''} />
            </div>
            <div className='col-md-4 mb-3 '>
              <TextField size="small" fullWidth label="Tollfree Comments (*)" variant="outlined" onChange={tollfreeComments}  value={tollFreeComment} />
            </div>
            <div className='col-md-4 mb-3 '>
              <TextField size="small" fullWidth label="Received Date Time" variant="outlined" value={productcode.length > 0 ? productcode[0].SERVICE_DATE : ''} />
            </div>
          </div>
        </Card>
        <hr />
        {!(checkboxes.checkbox1 && !checkboxes.checkbox2) && (
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
        <div className='col-md-12 shadow-none p-2 mb-2  rounded' style={{ background: '#FFF9C4', color: '#A50000' }}>
          <center>
            <h5 style={{ fontWeight: '600' }} className={classes.root}>Select Appropriate Actual Rewinding Charges</h5>
          </center>
          </div>
          <br />
          <div className="row">
            <div className='col-md-4 mb-3 '>
            <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>
              <InputLabel id="rewinding_charges">Rewinding Charges (*)</InputLabel>
                <Select
                  labelId="rewinding_charges"
                  id="rewinding"
                  value={rewindingList}
                  onChange={rewindingchargehandle}
                 label="Rewinding Charges"
                >
              <MenuItem value="W0001">Winding Wire</MenuItem>
               </Select>
    </FormControl>
              {/* <TextField size="small" fullWidth label="Rewinding Charges" variant="outlined" value={'abc'} /> */}
            </div>
			
            <div className='col-md-4 mb-3 '>
              <TextField type='number' size="small" fullWidth label="Unit Cost(Rs.)" id="windingAmount" variant="outlined" value={windingamount} onChange={windingAmounChange} />
            </div>
            <div className='col-md-4 mb-3 '>
            <FormControl variant="outlined" style={{ display: 'none' }} sx={{ width: '100%' }} className='col-md-4 mb-3'>
                <Select
                  labelId="repairs_and_maintenance"
                  id="repairs"
                  value={repairsList}
                  onChange={repairshandle}
                 label="Repairs and Maintenance"
                >
              <MenuItem value="S101">Repairs and Maintenance (Labour for Rewinding)</MenuItem>
               </Select>
    </FormControl>
              <Button variant="contained" fullWidth onClick={RewindingFormSubmit}><b>ADD</b></Button>
            </div>
          </div>
        </Card>
        )}
        <hr />
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
        <div className='col-md-12 shadow-none p-2 mb-2  rounded' style={{ background: '#FFF9C4', color: '#A50000' }}>
          <center>
            <h5 style={{ fontWeight: '600' }} className={classes.root}>Select Appropriate Replaced Actual Spares</h5>
          </center>
          </div>
          <br />
          <div className="row">
            <div className='col-md-3 mb-3 '>
            <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>
      <InputLabel id="Spares">Spares Consumed (*)</InputLabel>
      <Select
        labelId="Spares"
        id="spares_consumed"
        value={itemdetailsList}
        onChange={ItemdetailshandleChange}
        label="Spares Consumed"
      >
        <MenuItem value=""></MenuItem>
        {itemdetails.map((row, index) => (
          <MenuItem key={index} value={row.component_code}>{row.component_code} - {row.component_description}</MenuItem>
        ))}
      </Select>
        <br/>
            <FormControlLabel 
             style={{ display: 'flex', justifyContent: 'flex-end', width: '100%',marginRight:'100px' }} // This aligns it to the right
              control={
                <Checkbox 
                  checked={checked} 
                  disabled={isDataFromAPI}
                  onChange={handlechkbxxx} 
                  size="small" 
                />
              }
              label="Others"
            />
    </FormControl>
    
              {/* <TextField size="small" fullWidth label="Spares Consumed" variant="outlined" value={'abc'} /> */}
            </div>
            <div className='col-md-3 mb-3 '>
              <TextField size="small" fullWidth label="Quantity / Weight" onChange={quantityweightChange} variant="outlined" value={quantityweight} />
            </div>
            <div className='col-md-3 mb-3 '>
              <TextField size="small" fullWidth label="Unit Cost(Rs.)" onChange={unitCostChange} variant="outlined" value={unitCost} />
            </div>
            <div className='col-md-3 mb-3 '>
              <Button variant="contained" fullWidth  onClick={SparesReplacedClick}><b>ADD</b></Button>
            </div>
             {checked && (<div className="row">
                        <div className='col-md-3 mb-3 '>
                       
                        <TextField size="small" fullWidth label="" 
                        onChange={itemsearchchange} 
                        variant="outlined" 
                        value={itemsearch}
                         />
                        </div>
                        <div className='col-md-3 mb-3 '>
                        <Button variant="contained" fullWidth  
                        onClick={itemsearchbutton}
                        ><b>SEARCH</b></Button>
                        </div>
                        <div className='col-md-3 mb-3 '>
                         
                        </div>
                        <div className='col-md-3 mb-3 '>
                         
                        </div>
                  </div>)}
            {filteredTable.length > 0 ? (
        <TableContainer component={Paper}>
          <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
            <TableHead>
              <TableRow>
                {keys1.map((key) => (
                  <TableCell key={key} style={{ padding: '5px', background: '#F4C430', color: 'black' }}>
                    {key.replace(/_/g, ' ').toUpperCase()}
                  </TableCell>
                ))}
                <TableCell key="actions" style={{ padding: '5px', background: '#F4C430', color: 'black' }}>
                ACTIONS
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTable.map((row, index) => (
                row.Type !== "Labour" && (
                <TableRow key={index}>
                  {keys1.map((key) => (
                    <TableCell key={key} style={{ padding: '10px', background: '#FFF9C4', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      {row[key]}
                    </TableCell>
                  ))}
                  <TableCell key="delete" style={{ padding: '10px', background: '#FFF9C4', color: 'black' }}>
                    <Button variant="contained" style={{ background: '#d90429' }} onClick={() => handleDelete(row.id)}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              )))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className='row'>
          <div className='col-md-12 shadow-none p-3 mb-5 rounded' style={{ background: '#ced4da'}}>
            <div className='text-center'>
              <h6 className='text-white'><b>No Records Found</b></h6>
            </div>
          </div>
        </div>
      )}
          </div>
          <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-8"></div>
        <div className="col-lg-4 col-md-4 col-sm-4">
        <div className="d-flex flex-column">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
            <b>Total Value(A)</b>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">: {calculate}
            </div>
            </div>
            <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
            <span>Round Of Value(Rs.)</span> 
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">: {formattedSum}</div>
          </div>
          </div>
        </div>
          </div>
        </Card>
        <hr />
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
        <div className='col-md-12 shadow-none p-2 mb-2  rounded' style={{ background: '#FFF9C4', color: '#A50000' }}>
          <center>
            <h5 style={{ fontWeight: '600' }} className={classes.root}>Select Appropriate Labour / Service Performed</h5>
          </center>
          </div>
          <br />
          <div className="row">
            <div className='col-md-4 mb-3 '>
              {/* <TextField size="small" fullWidth label="Labour / Service Charge" variant="outlined" value={'abc'} /> */}
              <FormControl variant="outlined" size="small" sx={{ width: '100%' }} className='col-md-4 mb-3'>
        <InputLabel id="labour_service">Labour / Service Charge (*)</InputLabel>
        <Select
          labelId="labour_service"
          id="labour_service_charge"
          value={labourServiceChargeList}
          onChange={LabourServiceChargeHandel}
          label="Labour Service"
        >
          {labourServiceCharge.map((row,index) =>(
            <MenuItem key={index} value={row}>{row.service_name}</MenuItem>
          ))}
        </Select>
        </FormControl>
            </div>
			{selectedService === 'S106' && (
        <div className='col-md-3 mb-3'>
          <TextField size="small" type='number' fullWidth label="km" onChange={kmcharges} variant="outlined" value={km} />
        </div>
      )}
            <div className='col-md-4 mb-3 '>
              <TextField size="small" fullWidth label="Unit Cost(Rs.)" variant="outlined" onChange={labourServiceCostChage} value={labourServiceCost} />
            </div>
            <div className='col-md-4 mb-3 '>
              <Button variant="contained" fullWidth onClick={laberserviceHandleclicke}><b>ADD</b></Button>
            </div>
          </div>
          
          {filteredTable1.length > 0 ? (
        <TableContainer component={Paper}>
          <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
            <TableHead>
              <TableRow>
                {keys2.map((key) => (
                  <TableCell key={key} style={{ padding: '5px', background: '#F4C430', color: 'black' }}>
                    {key.replace(/_/g, ' ').toUpperCase()}
                  </TableCell>
                ))}
                <TableCell style={{ padding: '5px', background: '#F4C430', color: 'black' }}>ACTIONS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTable1.map((row, index) => (
                row.Type !== "Spare" && (
                  <TableRow key={index}>
                    {keys2.map((key) => (
                      <TableCell key={key} style={{ padding: '10px', background: '#FFF9C4', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                        {row[key]}
                      </TableCell>
                    ))}
                    <TableCell style={{ padding: '10px', background: '#FFF9C4', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                      <Button variant="contained" style={{ background: '#d90429' }} onClick={() => handleDelete(row.id)}>Delete</Button>
                    </TableCell>
                  </TableRow>
                )
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className='row'>
          <div className='col-md-12 shadow-none p-3 mb-5 rounded' style={{ background: '#ced4da'}}>
            <div className='text-center'>
              <h6 className='text-white'><b>No Records Found</b></h6>
            </div>
          </div>
        </div>
      )}
          <div className="row">
        <div className="col-lg-8 col-md-8 col-sm-8"></div>
        <div className="col-lg-4 col-md-4 col-sm-4">
        <div className="d-flex flex-column">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
            <b>Total Value(B)</b>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">: {Labour1}
            </div>
            </div>
            <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
            <span>Round Of Value</span>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">: {Labour2}</div>
          </div>
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
              <span>Labour Claim Value</span>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">: {Labour1}</div>
            </div>
            <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
            <b>Total Claim Value(A + B)</b>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">: {total_Claim_Value}
            </div>
            </div>
          </div>
        </div>
          </div>
        </Card>
        <hr />
        <Card className="shadow bg-light rounded" sx={{ padding: '30px' }} >
        <div className="row">
  <div className='col-md-4 mb-4'>
      <Upload {...createInvoiceImageProps(serialNoImage, setSerialNoImage)} maxCount={1}>
        <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Serial No Image</Btn>
      </Upload>
      {serialNoImage.length > 0 && (
        <img src={URL.createObjectURL(serialNoImage[0])} alt="Serial No" style={{ width: '100%', marginTop: '10px' }} />
      )}
    </div>
    <div className='col-md-4 mb-4'>
      <Upload {...createInvoiceImageProps(motorComponentImage, setMotorComponentImage)} maxCount={1}>
        <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Motor Component Image</Btn>
      </Upload>
      {motorComponentImage.length > 0 && (
        <img src={URL.createObjectURL(motorComponentImage[0])} alt="Motor Component" style={{ width: '100%', marginTop: '10px' }} />
      )}
    </div>
    <div className='col-md-4 mb-4'>
      <Upload {...createInvoiceImageProps(pumpComponentImage1, setPumpComponentImage1)} maxCount={1}>
        <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Pump Component Image1</Btn>
      </Upload>
      {pumpComponentImage1.length > 0 && (
        <img src={URL.createObjectURL(pumpComponentImage1[0])} alt="Pump Component 1" style={{ width: '100%', marginTop: '10px' }} />
      )}
    </div>
    </div>
    {/* <div className='col-md-3 mb-3'>
      <Upload {...createInvoiceImageProps(pumpComponentImage2, setPumpComponentImage2)} maxCount={1}>
        <Btn icon={<UploadOutlined />} style={{ width: '100%' }}>Pump Component Image2</Btn>
      </Upload>
      {pumpComponentImage2.length > 0 && (
        <img src={URL.createObjectURL(pumpComponentImage2[0])} alt="Pump Component 2" style={{ width: '100%', marginTop: '10px' }} />
      )}
    </div> */}
    <div className="row">
    <div className='col mb-12 mt-12'>
      <Btn type="primary" onClick={deliverychallanhandlesubmit} style={{ width: '100%' }}><b>Proceed For Delivery Challan</b></Btn>
    </div>
  </div>
        </Card>
      </div>
    </>
  );
}

export default ServiceClaimPending;